import React from "react";
import { CONTACT } from "@/constants/testIds";

const WhatsAppFloat = () => {
  return (
    <a
      data-testid={CONTACT.whatsappFloat}
      href="https://wa.me/5215583570588?text=Hola%20RAZMEK%2C%20me%20interesa%20una%20asesor%C3%ADa"
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 z-40 group"
      aria-label="Contactar por WhatsApp"
    >
      <div className="absolute inset-0 bg-razmek-gold/30 rounded-full blur-xl group-hover:bg-razmek-gold/50 transition" />
      <div className="relative flex items-center gap-3 bg-razmek-blue group-hover:bg-razmek-dark border border-razmek-gold/40 group-hover:border-razmek-gold transition-all px-5 py-3 rounded-full shadow-lg">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="#D89737"
          width="22"
          height="22"
        >
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.247-.694.247-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12.07 21.785a9.769 9.769 0 01-4.974-1.357l-.357-.211-3.696.97.987-3.6-.232-.37a9.785 9.785 0 1118.272-5.218 9.787 9.787 0 01-9.999 9.786zM12.064 0C5.391 0 0 5.39 0 12.063c0 2.121.557 4.193 1.615 6.013L0 24l6.083-1.592a12.05 12.05 0 005.973 1.515h.005c6.673 0 12.071-5.39 12.071-12.063 0-3.227-1.256-6.26-3.538-8.541a12.014 12.014 0 00-8.53-3.522z" />
        </svg>
        <span className="font-sans text-sm text-white tracking-wide hidden sm:inline">
          WhatsApp
        </span>
      </div>
    </a>
  );
};

export default WhatsAppFloat;
